var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3745 9.54099L18.4345 4.5H14.748C14.3338 4.5 13.998 4.16421 13.998 3.75C13.998 3.33579 14.3338 3 14.748 3H20.2498H20.2499L20.267 3.00019C20.3419 3.00189 20.4167 3.01474 20.4884 3.03875C20.5955 3.07457 20.6962 3.13522 20.7813 3.22067C20.9306 3.37052 21.0034 3.56767 20.9998 3.76368V9.23112C20.9998 9.64534 20.6641 9.98112 20.2498 9.98112C19.8356 9.98112 19.4998 9.64534 19.4998 9.23112V5.55598L14.4331 10.6036C14.1397 10.896 13.6648 10.8951 13.3725 10.6016C13.0801 10.3082 13.081 9.83333 13.3745 9.54099ZM10.6255 14.3969C10.9189 14.1046 10.9198 13.6297 10.6275 13.3363C10.3351 13.0428 9.86027 13.0419 9.56682 13.3343L4.5 18.3821V14.772C4.5 14.3578 4.16421 14.022 3.75 14.022C3.33579 14.022 3 14.3578 3 14.772L3 20.1879C3 20.1879 3 20.188 3 20.188L3 20.25C3 20.6642 3.33579 21 3.75 21H9.24866C9.66287 21 9.99866 20.6642 9.99866 20.25C9.99866 19.8358 9.66287 19.5 9.24866 19.5H5.5032L10.6255 14.3969Z",
    fill: "#081C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.dd3a14b7fe96342625d8044b4f63ea92.svg";
export { ForwardRef as ReactComponent };